import ContentEpisodeListItem from './ContentEpisodesListItem'
import Spinner from 'app/components/primitive/Spinner'
import { Select } from 'app/components/primitive/Form'
import { ContentEpisodesListProps } from './ContentEpisodesListProps'
import Section from 'app/components/structure/Section'
import { ContentCarousel } from 'app/components/content/ContentCarousel/ContentCarousel'
import { XStack } from '@mythical/ui'
import { useCallback } from 'react'

export const ContentEpisodesListHorizontal = (
  props: ContentEpisodesListProps,
) => {
  const {
    title,
    currentContentId,
    loading,
    episodes = [],
    seasons,
    season,
    onSeasonChange,
    onContentClick,
    ...stackProps
  } = props

  const handleSeasonChange = (season: string) => {
    onSeasonChange?.(season)
  }

  const initialScrollIndex = episodes.findIndex(
    (item) => item.id === currentContentId,
  )

  const renderItem = useCallback(
    (item: (typeof episodes)[0]) => (
      <ContentEpisodeListItem
        {...item}
        isActive={currentContentId === item.id}
        onNavigate={(e) => {
          e.preventDefault()
          onContentClick?.(item.id)
        }}
      />
    ),
    [currentContentId, onContentClick],
  )

  const keyExtractor = useCallback((item: (typeof episodes)[0]) => item.id, [])

  return (
    <Section
      title={title}
      customCta={
        !!seasons &&
        seasons.length > 1 && (
          <Select
            id="seasons"
            hideLabel
            theme="bgSecondaryOutlined"
            name="seasons"
            label="Select season"
            value={season}
            onValueChange={handleSeasonChange}
            options={seasons}
            size="$3"
            triggerProps={{ br: '$pill' }}
          />
        )
      }
      {...stackProps}
    >
      {loading && episodes.length === 0 && (
        <XStack py="$3.5" w="100%" jc="center" ai="center">
          <Spinner size="large" />
        </XStack>
      )}

      <ContentCarousel
        key={`season-${season}`} // Force re-render so that the carousel scrolls to the correct index
        items={episodes}
        keyExtractor={keyExtractor}
        initialScrollIndex={initialScrollIndex > -1 ? initialScrollIndex : 0}
        renderItem={renderItem}
      />
    </Section>
  )
}
